@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.error-wrapper {
  fill: @mark-as-shipped--error--fill-color;
  color: @mark-as-shipped--error--text-color;
  font-weight: @bold;
  font-size: 14px;
  display: flex;
  align-items: center;

  > svg {
    transform: scale(0.5);
  }
}
